import lodash from 'lodash'
import types from '@/store/mutation-types'
import { getBuildings } from '@/api/buildings/request'
import { SITE_TYPE } from '@/constants/modeltypes'

const defaultState = {
  buildings: [],
  buildingOptions: [],
}

// getters
const getters = {
  allBuildings: state => state.buildings,
  buildingOptions: state => state.buildingOptions,
  buildingIdContentMaps: state => {
    const map = state.buildings.reduce((result, building) => {
      if (!result[building.id]) {
        result[building.id] = building
      }
      return result
    }, {})
    return map
  },

}

// actions
const actions = {
  async getAllBuildings ({ commit }) {
    const buildings = await getBuildings()
    commit(types.GET_ALL_BUILDINGS, buildings)
  },
  async initBuildingOptions ({ state, dispatch }) {
    await dispatch(actions.getAllBuildings.name)
    const buildings = lodash.cloneDeep(state.buildings).map((item) => item.code)
    dispatch(actions.appendBuildingOptions.name, buildings)
  },
  appendBuildingOptions ({ state, commit }, data = []) {
    const oldBuildings = lodash.cloneDeep(state.buildingOptions)
    commit(
      types.ALL_BUILDINGS_OPTIONS,
      Array.from(new Set([...oldBuildings, ...data])),
    )
  },
  resetBuildingOptions ({ commit }) {
    commit(types.ALL_BUILDINGS_OPTIONS, [])
  },
  async getBuildingPhysicalSite ({ state }, buildingId) {
    const building = state.buildings.find(building => building.id === buildingId)
    return building.sites.find(site => site.type === SITE_TYPE.PHYSICAL)
  },
}

// mutations
const mutations = {
  [types.ALL_BUILDINGS_OPTIONS] (state, data) {
    state.buildingOptions = data
  },
  [types.GET_ALL_BUILDINGS] (state, buildings) {
    state.buildings = buildings
  },
  [types.RESET_STATE] (state) {
    state.buildings = []
  },
}

export default {
  namespaced: true,
  state: lodash.cloneDeep(defaultState),
  getters,
  actions,
  mutations,
}
